<app-section
  titleSection="Tendances et études du marché"
  [isLargeTitle]="true"
  [isActivated]="tendencies.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-tendance-marche-immobilier-read-mode
      [tendencies]="tendencies"
      [reportId]="reportId"
    >
    </app-tendance-marche-immobilier-read-mode>
  </div>

  <div edit-mode>
    <app-tendance-marche-immobilier-edit-mode
      [tendencies]="tendencies"
      [reportId]="reportId"
      (tendenciesChanged)="onTendenciesChanged($event)"
    >
    </app-tendance-marche-immobilier-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
